export const admissionSteps = [
  {
    step: 'Step 1',
    title: 'Send an enquiry',
    body: 'One short form. We reply within two working days with real dates, not a brochure.',
  },
  {
    step: 'Step 2',
    title: 'Visit on a normal day',
    body: 'No staged open day. Come at 10am on a Tuesday and see the school as it actually is.',
  },
  {
    step: 'Step 3',
    title: 'A morning together',
    body: 'Your child spends a morning in class. It is play, not a test — we are checking fit, not ranking.',
  },
  {
    step: 'Step 4',
    title: 'Enrol & first day',
    body: 'Paperwork takes twenty minutes. Their teacher calls you the evening before day one.',
    emphasis: true,
  },
];
